import { TFunction } from "i18next";
import { useEffect } from "react";
import { APP_DOMAIN } from "../../utls/constants";

interface IOrganizationStructuredData {
  t: TFunction<"translation", undefined>;
}

const useOrganizationStructuredData = ({ t }: IOrganizationStructuredData) => {
  useEffect(() => {
    let scriptOrganization = document.querySelector('script[type="application/ld+json"][data-type="organization"]') as HTMLScriptElement;

    if (!scriptOrganization) {
      scriptOrganization = document.createElement("script");
      scriptOrganization.type = "application/ld+json";
      scriptOrganization.setAttribute("data-type", "organization");
      document.head.appendChild(scriptOrganization);
    }

    scriptOrganization.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "@id": `https://www.${APP_DOMAIN}/#organization`,
      name: "Twizz",
      url: `https://www.${APP_DOMAIN}/`,
      logo: `https://www.${APP_DOMAIN}/static/media/white-twizz.80b58d094e1ef790f54a.webp`,
      description: t("organization_structured_data_description"),
      foundingDate: "2024-09-15",
      email: `support@${APP_DOMAIN}`,
      areaServed: {
        "@type": "Country",
        name: "France",
      },
    });

    return () => {
      if (scriptOrganization) {
        scriptOrganization.remove();
      }
    };
  }, [t]);
};

export default useOrganizationStructuredData;
